/**************************************************************************
Name:  contactPartial.js
Description:  scripting to submit partial contact form completion
Date Created: 12/23/2015; Nick Guidry
Modified:
**************************************************************************/

loadEvents[loadEvents.length] = function( ){

    $('#portraitContactForm input[name="email"], #portraitContactForm textarea[name="message"], #portraitContactForm input[name="firstname"], #portraitContactForm input[name="lastname"], #portraitContactForm input[name="phone"], #portraitContactForm input[name="company"], #portraitContactForm input[name="referredBy"], #contactForm input[name="email"], #contactForm textarea[name="message"], #contactForm input[name="firstname"], #contactForm input[name="lastname"], #contactForm input[name="phone"], #contactForm input[name="company"], #contactForm input[name="referredBy"], #consultationForm input[name="email"], #consultationForm textarea[name="message"]').blur(function(){

        var theForm = $(this).closest('form');

        if (theForm.attr('id') == "contactForm" || theForm.attr('id') == "portraitContactForm"){
         theForm.find('input[name="formType"]').val('1');
        } else if (theForm.attr('id') == "consultationForm"){
          theForm.find('input[name="formType"]').val('2');
        }
           
    	//submit form via ajax to validate/create temp
    	$.ajax( {
    		type : 'POST',
    		url : '/content/getTempLead/',
    		dataType: 'json',
    		data : theForm.serialize(),
    		success: function(html){
				theForm.find('input[name="tempID"]').val(html);
			}
		});
       
	});

}

